module.exports = __webpack_public_path__ + "static/img/14.a997e0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/14.png
// module id = xwPM
// module chunks = 0